// extracted by mini-css-extract-plugin
module.exports = {"input":"input-module--input--1NqSl","input__label":"input-module--input__label--KQcP2","input__input":"input-module--input__input--mlz5d"};